import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = function (a0) { return { mobile: a0 }; };
class LoaderComponent {
    constructor() {
        /** Controls loader size */
        this.mobileView = false;
    }
    ngOnInit() { }
}
LoaderComponent.ɵfac = function LoaderComponent_Factory(t) { return new (t || LoaderComponent)(); };
LoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoaderComponent, selectors: [["mis-loader"]], inputs: { mobileView: "mobileView" }, decls: 1, vars: 3, consts: [["id", "spinner", 3, "ngClass"]], template: function LoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx.mobileView));
    } }, dependencies: [ɵngcc1.NgClass], styles: ["#spinner[_ngcontent-%COMP%]{-webkit-animation:frames 1s linear infinite;animation:frames 1s linear infinite;background:transparent;border-radius:100%;border:4px solid #e0e0e0;border-top-color:#6200ee;width:40px;height:40px;padding:0;position:absolute}@-webkit-keyframes frames{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}@keyframes frames{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.mobile[_ngcontent-%COMP%]{height:20px!important;width:20px!important;border:2px solid #e0e0e0!important;border-top-color:#6200ee!important}"] });
LoaderComponent.ctorParameters = () => [];
LoaderComponent.propDecorators = {
    mobileView: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderComponent, [{
        type: Component,
        args: [{ selector: "mis-loader", template: "<div\n  id=\"spinner\"\n  [ngClass]=\"{\n    mobile: mobileView\n  }\"\n></div>\n", styles: ["#spinner{-webkit-animation:frames 1s linear infinite;animation:frames 1s linear infinite;background:transparent;border-radius:100%;border:4px solid #e0e0e0;border-top-color:#6200ee;width:40px;height:40px;padding:0;position:absolute}@-webkit-keyframes frames{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}@keyframes frames{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.mobile{height:20px!important;width:20px!important;border:2px solid #e0e0e0!important;border-top-color:#6200ee!important}"] }]
    }], function () { return []; }, { mobileView: [{
            type: Input
        }] }); })();

class LoaderModule {
    static forRoot() {
        return { ngModule: LoaderModule, providers: [] };
    }
}
LoaderModule.ɵfac = function LoaderModule_Factory(t) { return new (t || LoaderModule)(); };
LoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LoaderModule });
LoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderModule, [{
        type: NgModule,
        args: [{
                declarations: [LoaderComponent],
                imports: [CommonModule],
                exports: [LoaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoaderModule, { declarations: function () { return [LoaderComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [LoaderComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LoaderComponent, LoaderModule };

